export default "__VITE_ASSET__56ba86b7__"